<!-- 文件管理 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <purchaseOrderAction v-if="showStatus" ref="purchaseOrderAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></purchaseOrderAction>
        </el-drawer>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch"></v-search>
            </div>
        </div>
        <div class="page_content_center">
            <el-table v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" @selection-change="handleSelectionChange"
                      highlight-current-row size="mini" @sort-change="sortChange">
                <el-table-column type="selection" width="40">
                </el-table-column>
                <!-- 主表格 -->
                <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                    <el-table-column v-if="tableValye.isShow == 1" align="center" :key="tableKey" show-overflow-tooltip :prop="tableValye.entityField" :min-width="tableValye.fieldWeight" :label="tableValye.showField"
                                     :sortable="tableValye.isSort == 1 ? true : false">
                        <template slot-scope="scope">
                            <el-tag size="mini" v-if="tableValye.entityField == 'isWms'">
                                {{ scope.row.isWms == 0 ? '否' : '是' }}
                            </el-tag>
                            <span v-else-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                            </span>
                            <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                            </span>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField] }}</a>
                            </span>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <upFile ref="upFile"></upFile>
        <el-dialog :title="'查看' + upType" :visible.sync="diaContract" width="800px">
            <el-button type="primary" size="mini" @click="printImgs()" style="margin-bottom: 10px;">
                批量打印
            </el-button>
            <el-button type="primary" size="mini" @click="batchDownLoad()" style="margin-bottom: 10px;">
                批量下载
            </el-button>
            <div class="fileTable">
                <el-table size="mini" :data="fileData" border style="width: 100%">
                    <el-table-column prop="codingNum" show-overflow-tooltip label="编码"></el-table-column>
                    <el-table-column prop="busType" show-overflow-tooltip label="业务类型"></el-table-column>
                    <el-table-column prop="createrName" show-overflow-tooltip label="上传人"></el-table-column>
                    <el-table-column prop="createTime" show-overflow-tooltip label="上传时间">
                        <template slot-scope="scope">
                            <span v-if="scope.row.createTime">
                                {{ $common.getLocalTime(scope.row.createTime) }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="fileName" show-overflow-tooltip label="文件名"></el-table-column>
                    <el-table-column prop="fileType" show-overflow-tooltip label="文件类型"></el-table-column>
                    <el-table-column prop="fileUrl" show-overflow-tooltip label="附件">
                        <template slot-scope="scope">
                            <ul v-if="scope.row.fileUrl">
                                <li style="display: flex;align-items: center;flex-wrap: wrap; width: 31px;height: 31px;margin-right: 5px;" v-for="(item, index) in scope.row.fileUrl.split(',')" :key="index">
                                    <cusImage style="width: 30px;height: 30px;" :src="$common.getFileAddress(item)" :preview-src-list="$common.getFileAddressARR(scope.row.fileUrl.split(','))">
                                    </cusImage>
                                </li>
                            </ul>
                        </template>
                    </el-table-column>
                    <el-table-column width="135" label="操作">
                        <template slot-scope="scope">
                            <div class="imgs">
                                <el-link @click="downLoadFile(scope.row.fileUrl)" type="primary" :underline="false" style="margin-left:10px">另存为</el-link>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>
        <el-dialog title="批量打印" :visible.sync="diaImgs" width="990px">
            <el-button type="primary" @click="handlePrint" size="mini" style="margin-bottom:10px">打印</el-button>
            <div style="width: 967px;">
                <div v-for="(key, index) in fileData" :key="index" style="height: 1405px;width: 967px; position: relative; ">
                    <iframe v-if="isPdfFile(key)" :src="$common.getFileAddress(key.fileUrl)" style="width: 967px;height: 1400px;border: none;"></iframe>
                    <el-image v-else-if="key.flag" :style="`width: 1400px;height: 960px;transform: rotateZ(90deg);position: absolute;left:-217px;bottom:219px;`" :src="$common.getFileAddress(key.fileUrl)"
                              fit="contain"></el-image>
                    <el-image v-else :style="`width: 960px;height: 1400px;`" :src="$common.getFileAddress(key.fileUrl)" fit="contain"></el-image>
                    <div v-if="isPrintTag && hasPrintTag(key)" class="print-tag">
                        <div v-if="getPrintTag(key).woamId" class="tag-line">{{ getPrintTag(key).woamId }}</div>
                        <div v-if="getPrintTag(key).cmName" class="tag-line tag-sub">{{ getPrintTag(key).cmName }}</div>
                    </div>
                    <div style="page-break-after: always;"></div>
                </div>
            </div>
        </el-dialog>
        <!-- 质检报告提示：表格样式展示选中行有无质检报告，无报告标红；z-index 固定保证显示在批量打印弹窗之上 -->
        <el-dialog title="质检报告提示" :visible.sync="diaReportTip" width="600px" append-to-body style="z-index: 3000;">
            <el-table :data="reportTipData" border size="mini" max-height="400">
                <el-table-column prop="bgmName" show-overflow-tooltip label="通用名称"></el-table-column>
                <el-table-column prop="batchno" show-overflow-tooltip label="批号"></el-table-column>
                <el-table-column label="有无质检报告" width="120" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.has">有质检报告</span>
                        <span v-else style="color:#f56c6c;font-weight:bold;">无质检报告</span>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer">
                <el-button type="primary" size="mini" @click="diaReportTip = false">确 定</el-button>
            </div>
        </el-dialog>
        <div id="print-container" style="display: none;"></div>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import SearchScheme from "../../../byComponents/SearchScheme.vue";
import upFile from '@/components/upFile.vue'
import { printRecordAdd } from '@/service/printApi.js'
import * as pdfjsLib from 'pdfjs-dist/build/pdf'
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker
//例如：import 《组件名称》 from '《组件路径》';
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        upFile
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            diaImgs: false,
            getRequestData: {
                psomBuycus: "",
                smName: "",
                page: 1,
                rows: 30,
                start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
                cmId: "",
                cmName: "",
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],
            pageShowData: [],
            formDataList: [],
            selectedDataIndex: 0,
            seId: "",
            seWidth: "",
            seTitle: "",
            DialogVisible: false,
            seType: "",
            smId: "",
            isShowTooltip: false,
            showStatus: false,
            actionData: {},
            fileSelect: '',
            diaContract: false, //合同
            diaInspectionReport: false, // 检验报告
            diaInvoice: false, // 发票
            diaWithCar: false, // 随货同行
            multipleSelection: [],
            fileIds: [], //明细id数组 明细单号
            busynessKey: [], //记账单号
            fileData: [],   //合同数据
            diaReportTip: false, //质检报告提示弹窗
            reportTipData: [], //质检报告提示数据（选中行的有无报告情况）
            diaTitle: '上传合同',
            upType: 1,
            url: require('@/assets/img/other/look.png'),
            requesUrl: '',
            imgUrl: '',
            fileType: [{
                key: 1,
                value: '图片'
            },
            {
                key: 2,
                value: '文件'
            },
            {
                key: 3,
                value: '视频'
            },
            {
                key: 4,
                value: '音频'
            },
            {
                key: 5,
                value: '未识别'
            },
            ],
            urls: [],
            parentSearchData: {},
            ormId: '',
            isPrintTag: false, // 打印时是否在图片右上角叠加销售单号/客户名称
            printTagMap: {}, // 明细id => { woamId, cmName }
            printTagDefault: { woamId: "", cmName: "" },
            isPage:false,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "getRequestData.cmName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.cmId = "";
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        sortChange(column) {
            this.returnData.list = this.$common.sortChange(column, this.returnData.list, this.pageShowData.jurTableVo.jurconfigtable, 'entityField')
        },
        printImgs() {
            this.diaImgs = true
        },
        // 根据表格列名反查真实字段名（列配置动态，字段名可能不固定）
        getFieldByLabel(label, defaultField) {
            const cols = (this.pageShowData.jurTableVo && this.pageShowData.jurTableVo.jurconfigtable) || []
            const col = cols.find(item => item.showField && item.showField.indexOf(label) > -1)
            return (col && col.entityField) || defaultField
        },
        // 记录打印时需要叠加到图片右上角的 销售单号/客户名称
        setPrintTag() {
            this.printTagMap = {}
            this.printTagDefault = { woamId: "", cmName: "" }
            const woamField = this.getFieldByLabel('销售单号', 'woamId')
            const cmField = this.getFieldByLabel('客户名称', 'cmName')
            this.multipleSelection.forEach((row, index) => {
                const tag = { woamId: row[woamField] || row.woamId || "", cmName: row[cmField] || row.cmName || "" }
                if (index == 0) this.printTagDefault = tag
                const key = row.wobkedId !== undefined && row.wobkedId !== null ? row.wobkedId : row.bgmId
                if (key !== undefined && key !== null) this.printTagMap[key] = tag
            })
        },
        // 取某张图片对应的标记信息（逐行请求时已按行打上 printTagInfo，兜底用第一行）
        getPrintTag(item) {
            if (!item) return this.printTagDefault
            return item.printTagInfo || this.printTagDefault
        },
        // 判断图片是否有可显示的标记内容（销售单号/客户名称至少一个有值）
        hasPrintTag(item) {
            const tag = this.getPrintTag(item)
            return !!(tag && (tag.woamId || tag.cmName))
        },
        escapeHtml(str) {
            if (str === undefined || str === null) return ''
            return String(str).replace(/[&<>"']/g, function (s) {
                return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[s]
            })
        },
        isPdfFile(item) {
            if (!item) return false
            const url = String(item.fileUrl || '').toLowerCase()
            const name = String(item.fileName || '').toLowerCase()
            const type = String(item.fileType || '').toLowerCase()
            return url.includes('.pdf') || name.endsWith('.pdf') || type.includes('pdf')
        },
        loadImageItem(item) {
            return new Promise((resolve, reject) => {
                const img = new Image()
                const imgSrc = this.$common.getFileAddress(item.fileUrl)
                img.onload = () => resolve({ item, img, src: imgSrc })
                img.onerror = () => reject(new Error(`图片加载失败: ${imgSrc}`))
                img.src = imgSrc
            })
        },
        async renderPdfToImages(pdfUrl) {
            const loadingTask = pdfjsLib.getDocument(pdfUrl)
            const pdf = await loadingTask.promise
            const pages = []
            for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
                const page = await pdf.getPage(pageNum)
                const viewport = page.getViewport({ scale: 2.5 })
                const canvas = document.createElement('canvas')
                const context = canvas.getContext('2d')
                canvas.height = viewport.height
                canvas.width = viewport.width
                await page.render({
                    canvasContext: context,
                    viewport: viewport
                }).promise
                pages.push({
                    dataUrl: canvas.toDataURL('image/jpeg', 0.92),
                    width: viewport.width,
                    height: viewport.height
                })
            }
            return pages
        },
        async loadPrintPageList() {
            const pages = []
            for (const item of this.fileData) {
                if (this.isPdfFile(item)) {
                    const pdfUrl = this.$common.getFileAddress(item.fileUrl)
                    const pdfPages = await this.renderPdfToImages(pdfUrl)
                    pdfPages.forEach((page, pageIndex) => {
                        pages.push({
                            item,
                            src: page.dataUrl,
                            nw: page.width,
                            nh: page.height,
                            needRotate: page.width > page.height,
                            showPrintTag: pageIndex === 0
                        })
                    })
                } else {
                    const { item: loadedItem, img, src } = await this.loadImageItem(item)
                    pages.push({
                        item: loadedItem,
                        src,
                        nw: img.naturalWidth || 1,
                        nh: img.naturalHeight || 1,
                        needRotate: (img.naturalWidth || 1) > (img.naturalHeight || 1),
                        showPrintTag: true
                    })
                }
            }
            return pages
        },
        // 记录检验报告打印次数：按选中行的 wobkedId 逐条上报
        recordPrintCount() {
            const token = sessionStorage.getItem('token')
            if (!token) return
            const pathInfo = parent.getMenuInfo(this.$route.path)
            this.multipleSelection.forEach(row => {
                printRecordAdd({ businessId: row.wobkedId, printName: '检验报告打印', printId: pathInfo.jurId }, token)
            })
        },
        async handlePrint() {
            const printContainer = document.getElementById('print-container')
            if (!printContainer || this.fileData.length === 0) return
            this.$message({
                type: 'info',
                message: '正在加载文件，请稍候...',
                duration: 0
            })

            try {
                const printPages = await this.loadPrintPageList()
                this.$message.closeAll()

                let printContent = '<!DOCTYPE html><html><head><meta charset="UTF-8"><title>批量打印</title>'
                printContent += '<style>'
                printContent += '@page { margin: 5mm; size: auto; }'
                printContent += '* { margin: 0; padding: 0; box-sizing: border-box; }'
                printContent += 'html, body { margin: 0; padding: 0; width: 100%; height: 100%; }'
                printContent += '.print-page { page-break-after: always; page-break-inside: avoid; width: 100%; height: 100vh; min-height: 100vh; display: flex; justify-content: center; align-items: center; overflow: visible; position: relative; }'
                printContent += '.print-page.last-page { page-break-after: avoid; }'
                printContent += '.print-page img { display: block; max-width: 100%; max-height: 100%; width: auto; height: auto; object-fit: contain; }'
                printContent += '.print-page img.rotate-img { position: absolute; top: 50%; left: 50%; max-width: calc(100vh - 10mm); max-height: calc(100vw - 10mm); transform: translate(-50%, -50%) rotate(90deg); }'
                printContent += '.page-num { position: absolute; right: 12px; bottom: 10px; z-index: 10; font-size: 14px; color: #000; font-family: Arial, sans-serif; background: rgba(255,255,255,0.75); padding: 2px 8px; border-radius: 2px; }'
                printContent += '.print-tag { position: absolute; top: 1%; right: 5.5%; z-index: 10; text-align: right; font-family: "Microsoft YaHei", SimSun, Arial, sans-serif; color: #000; }'
                printContent += '.print-tag .tag-line { display: inline-block; font-size: 18px; font-weight: 600; line-height: 1.5; letter-spacing: 1px; background: rgba(255,255,255,0.72); padding: 1px 6px; white-space: nowrap; }'
                printContent += '.print-tag .tag-sub { margin-top: 5px; font-size: 15px; font-weight: 500; letter-spacing: 0.5px; }'
                printContent += '</style></head><body>'

                const totalPages = printPages.length
                printPages.forEach((page, index) => {
                    const isLast = index === totalPages - 1
                    const pageClass = isLast ? 'print-page last-page' : 'print-page'
                    printContent += `<div class="${pageClass}">`
                    const imgClass = page.needRotate ? 'rotate-img' : ''
                    printContent += `<img class="${imgClass}" src="${page.src}" alt="" />`
                    if (this.isPrintTag && page.showPrintTag) {
                        const tag = this.getPrintTag(page.item)
                        if (tag && (tag.woamId || tag.cmName)) {
                            printContent += '<div class="print-tag">'
                            if (tag.woamId) printContent += `<div class="tag-line">${this.escapeHtml(tag.woamId)}</div>`
                            if (tag.cmName) printContent += `<div class="tag-line tag-sub">${this.escapeHtml(tag.cmName)}</div>`
                            printContent += '</div>'
                        }
                    }
                    if (this.isPage) {
                        printContent += `<div class="page-num">${index + 1} / ${totalPages}</div>`
                    }
                    printContent += '</div>'
                })

                printContent += '</body></html>'

                const printWindow = window.open('', '_blank')
                if (!printWindow) {
                    this.$message.error('浏览器阻止了弹出窗口，请允许弹出窗口后重试')
                    return
                }

                printWindow.document.write(printContent)
                printWindow.document.close()

                printWindow.onload = () => {
                    setTimeout(() => {
                        this.recordPrintCount()
                        printWindow.print()
                        printWindow.close()
                        this.diaImgs = false
                        this.diaContract = false
                    }, 500)
                }
            } catch (error) {
                this.$message.closeAll()
                this.$message.error('文件加载失败: ' + error.message)
            }
        },
        //下载压缩包
        downLoadFile(e) {
            window.location.href = this.requesUrl + '/psaccount/downDetailFile?url=' + e
        },
        //批量下载压缩包
        batchDownLoad(e) {
            window.location.href = this.requesUrl + '/wobke/downFileZip?busynessId=' + this.fileIds.toString() +
                '&&busynessType=' + this.upType
        },
        //   删除文件
        async delFile(e) {
            this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(async () => {
                let params = {
                    ids: [e]
                }
                let responseData = await this.$http.delFile(params);
                if (responseData.status == 200) {
                    this.$message({
                        type: "success",
                        message: "删除成功!",
                    });
                    this.getFileListByIds()
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            }).catch(() => { });
        },
        //  打开文件上传组件
        openFile() {
            this.$refs['upFile'].openFileDia()
        },
        //多选
        handleSelectionChange(val) {
            this.multipleSelection = val;
            // 查看弹窗打开期间取消勾选时，同步剔除对应行的文件（文件项通过 woadId 对应行的 wobkedId；
            // 无 woadId 的文件无法对应行，予以保留）
            if (this.diaContract && this.fileData.length > 0) {
                const checkedKeys = val.map(row => row.wobkedId);
                this.fileData = this.fileData.filter(f => f.woadId === undefined || checkedKeys.includes(f.woadId));
                this.urls = this.fileData.map(item => this.imgUrl + '/' + item.fileUrl);
            }
        },
        // 子组件触发
        drawerCancel(e) {
            this.showStatus = false;
            if (e == 1) this.getDataList();
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页
                var isPenetrate = true;
                // 设置缓存 存入点击单号
                this.resetSetItem("penetrateOrderId", orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({
                    //向窗口发送MessageEvent消息
                    cmd: "returnFormJson",
                    params: {
                        isPenetrate
                    }, //参数
                },
                    "*"
                );
            }
        },
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
            // this.sendDataInfo.pisOrderDetail[this.seIndex].bgmName = val.bgmName
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },

        getSearchName(e) {
            this.seTitle = e;
        },

        // 检索Id, 索引(表格中), 标识
        openSearch({ sId, index, type, sField }) {
            this.DialogVisible = true;
            this.seId = sId;
            this.seType = type
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]
        },

        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            });
            if (responseData.status == 200) {
                this.pageShowData = responseData.result;
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList();
                this.getButtonList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 动作集合
        actionSet(actionData) {
            if (actionData.actionType != 15 && actionData.actionType != 99) {
                if (this.multipleSelection.length == 0) {
                    this.$message({
                        message: "请先选中要操作的数据",
                        type: "error",
                    });
                    return false;
                }
            }

            switch (actionData.actionType) {
                case 11:
                    this.upType = '合同'
                    this.isPrintTag = false
                    this.getFileListByIds()
                    break;
                case 12:
                    this.upType = '检验报告'
                    // 配置项控制是否显示：config.js 中 isFilePrintTag 为 true 才显示
                    this.isPrintTag = window.global_config.isFilePrintTag === true
                    // 根据质检报告数量 zjbbNumber 判断选中行有无质检报告，弹表格提示，无报告的标红（不拦截流程）
                    this.reportTipData = this.multipleSelection.map(row => ({
                        bgmName: row.bgmName || '',
                        batchno: row.batchno || '',
                        has: Number(row.zjbbNumber) > 0
                    }))
                    this.diaReportTip = this.reportTipData.some(item => !item.has)
                    this.setPrintTag()
                    this.getFileListByIds()
                    break;
                case 13:
                    this.upType = '发票'
                    this.isPrintTag = false
                    this.getFileListByIds()
                    break;
                case 14:
                    this.upType = '随货同行'
                    this.isPrintTag = false
                    this.getFileListByIds()
                    break;
                case 15:
                    this.upType = '商品证照'
                    this.isPrintTag = false
                    this.getFileListByIds()
                    break;
                case 16:
                    this.upType = '供应商证照'
                    this.isPrintTag = false
                    this.getFileListByIds()
                    break;
                case 99: //导出
                    this.exportFile()
                    break;
            }
        },
        // 导出文件
        async exportFile() {
            window.location.href = this.requesUrl + '/wobke/exportOwnertransferNew?psomBuycus=' + this.getRequestData.psomBuycus
                + '&smName=' + this.getRequestData.smName + '&cmId=' + this.getRequestData.cmId + '&cmName=' + this.getRequestData.cmName
                + '&start=' + (this.getRequestData.start || '') + '&end=' + (this.getRequestData.end || '')
                + '&page=' + this.getRequestData.page + '&rows=' + this.getRequestData.rows + '&ormId=' + String(this.ormId)
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 通过明细id查询文件列表
        async getFileListByIds() {
            this.urls = []
            this.fileIds = []
            this.busynessKey = []
            this.multipleSelection.forEach(item => {
                if (this.upType == '商品证照') {
                    this.fileIds.push(item.bgmId)
                } else if (this.upType == '供应商证照') {
                    this.fileIds.push(item.bgsId)
                } else {
                    this.fileIds.push(item.wobkedId)
                }
            })
            let params = {
                busynessId: this.fileIds,
                fileType: this.upType
            }
            let responseData;
            if (this.upType == '商品证照' || this.upType == '供应商证照') {
                responseData = await this.$http.querylicenceFileListByIds(params);
            } else {
                // 批量调用一次即可，返回项带 woadId（对应明细行的 wobkedId），可把文件对应回明细行
                responseData = await this.$http.querySalesFileListByIds(params);
                // 检验报告需在图片右上角打印单号/客户标记：按 woadId 找到对应行的标记信息
                if (this.isPrintTag && responseData.status == 200 && responseData.result && responseData.result.list) {
                    responseData.result.list.forEach(f => {
                        f.printTagInfo = this.printTagMap[f.woadId] || this.printTagDefault
                    })
                }
            }
            if (responseData.status == 200) {
                this.fileData = responseData.result.list
                this.fileData.forEach(item => {
                    if (this.isPdfFile(item)) {
                        item.isPdf = true
                        return
                    }
                    item.isPdf = false
                    const src = this.imgUrl + '/' + item.fileUrl
                    const img = new Image()

                    img.src = src
                    img.onload = () => {
                        if (img.width > img.height) {
                            item.flag = true
                        } else {
                            item.flag = false
                        }
                    }
                })
                responseData.result.list.forEach(item => {
                    this.urls.push(this.imgUrl + '/' + item.fileUrl)
                })
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
            this.diaContract = true
        },
        showPrintPlan() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                var info = this.returnData.list[this.selectedDataIndex];
                this.$refs.printPlan.openDia(info.psomId);
            } else {
                return;
            }
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.querySalesFileList(
                this.getRequestData
            );
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.pages = responseData.result.pages;
                this.returnData.total = responseData.result.total;
                this.returnData.pageNum = responseData.result.pageNum;
                this.selectedDataIndex = 0;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 删除数据
        delDataAction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }

            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.psomId],
                    };
                    let responseData = await this.$http.delPurchaseOrder(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
//获取图片存取的根路径
        imgurl() {
            // console.log(this.$store.getters.getConfig);
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.imgurl()
        this.getPageInfo();
        this.ormId = sessionStorage.getItem('ormId')
        this.isPage=window.global_config.isPage||false

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.el-drawer {
    outline: none;
}

.el-link {
    font-size: 12px !important;
}

.imgs {
    display: flex;
    align-items: center;
}

.print-tag {
    position: absolute;
    top: 1%;
    right: 5.5%;
    z-index: 10;
    text-align: right;
    font-family: "Microsoft YaHei", SimSun, Arial, sans-serif;
    color: #000;
}

.print-tag .tag-line {
    display: inline-block;
    font-size: 18px;
    font-weight: 600;
    line-height: 1.5;
    letter-spacing: 1px;
    background: rgba(255, 255, 255, 0.72);
    padding: 1px 6px;
    white-space: nowrap;
}

.print-tag .tag-sub {
    margin-top: 5px;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0.5px;
}

/* ::v-deep.el-image img {
   margin-top: 2px;
} */
</style>